<script setup lang="ts">
import { SEARCH_ICON_URL } from '~/pages/market/constants'

defineProps<{
  displayName: string
  loading: boolean
}>()

defineEmits<{
  open: []
}>()
</script>

<template>
  <button
    type="button"
    class="wikitrade-symbol-trigger"
    data-testid="wikitrade-symbol-open"
    :aria-busy="loading"
    :disabled="loading"
    @click.stop.prevent="$emit('open')"
  >
    <span class="wikitrade-symbol-trigger__text">
      <span class="wikitrade-symbol-trigger__name">{{ displayName }}</span>
    </span>
    <span class="wikitrade-symbol-trigger__icon" aria-hidden="true">
      <span v-if="loading" class="wikitrade-symbol-trigger__spinner" />
      <CommonImage v-else :src="SEARCH_ICON_URL" class="wikitrade-search-icon" alt="search" />
    </span>
  </button>
</template>

<style scoped lang="less">
.wikitrade-symbol-trigger {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 136px;
  max-width: 260px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid #d8dde8;
  border-radius: 6px;
  background: #ffffff;
  color: #111827;
  cursor: pointer;
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease;

  &:hover {
    border-color: #0f4fd6;
    box-shadow: 0 0 0 3px rgba(15, 79, 214, 0.08);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
}

.wikitrade-symbol-trigger__text {
  min-width: 0;
  flex: 1;
}

.wikitrade-symbol-trigger__name {
  display: block;
  overflow: hidden;
  font-size: 14px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wikitrade-symbol-trigger__icon {
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  color: #53627c;
  flex: 0 0 auto;
}

.wikitrade-symbol-trigger__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #d8dde8;
  border-top-color: #0f4fd6;
  border-radius: 999px;
  animation: wikitrade-spin 0.8s linear infinite;
}

.wikitrade-search-icon {
  width: 16px;
  height: 16px;
}

@keyframes wikitrade-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
